import { render, staticRenderFns } from "./SearchableAuthorList.vue?vue&type=template&id=fe8e269a&scoped=true&"
import script from "./SearchableAuthorList.vue?vue&type=script&lang=js&"
export * from "./SearchableAuthorList.vue?vue&type=script&lang=js&"
import style0 from "./SearchableAuthorList.vue?vue&type=style&index=0&id=fe8e269a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8e269a",
  null
  
)

export default component.exports